"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Chat;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _ChatModule = _interopRequireDefault(require("./Chat.module.scss"));

var _Controls = _interopRequireDefault(require("./components/Controls/Controls"));

var _EChatChannel = _interopRequireDefault(require("./EChatChannel"));

var _MessagesStream = _interopRequireDefault(require("./components/MessagesStream/MessagesStream"));

var _mockMessages = _interopRequireDefault(require("./mockMessages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Chat(_ref) {
  var _ref$initialWidth = _ref.initialWidth,
      initialWidth = _ref$initialWidth === void 0 ? 200 : _ref$initialWidth,
      _ref$initialHeight = _ref.initialHeight,
      initialHeight = _ref$initialHeight === void 0 ? 128 : _ref$initialHeight,
      className = _ref.className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var windowRef = (0, _react.useRef)(null);
  var resizerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(initialWidth),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(initialHeight),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMouseDown = _useState6[0],
      setIsMouseDown = _useState6[1];

  var _useState7 = (0, _react.useState)(_EChatChannel.default.GUILD),
      _useState8 = _slicedToArray(_useState7, 2),
      focusedChannel = _useState8[0],
      setFocusedChannel = _useState8[1];

  var _useState9 = (0, _react.useState)([_EChatChannel.default.GENERAL, _EChatChannel.default.PARTY]),
      _useState10 = _slicedToArray(_useState9, 2),
      enabledChannels = _useState10[0],
      setEnabledChats = _useState10[1];

  var focusChannel = (0, _react.useCallback)(function (channel) {
    if (channel === _EChatChannel.default.SYSTEM) return;
    if (channel === _EChatChannel.default.DAMAGE) return;
    setFocusedChannel(channel);
  }, []);
  var toggleChatEnabled = (0, _react.useCallback)(function (chatType) {
    setEnabledChats(function (prev) {
      var newState = [];

      if (prev.includes(chatType)) {
        newState = prev.filter(function (entry) {
          return entry !== chatType;
        });
      } else {
        newState = prev.concat(chatType);
      }

      return newState;
    });
  }, []);
  var changeVal = (0, _react.useCallback)(function (event) {
    var documentHeight = document.documentElement.offsetHeight;
    setWidth(event.clientX - 22);
    setHeight(documentHeight - event.clientY + 22 / 2);
  }, []);
  var handleMouseMove = (0, _react.useCallback)(function (event) {
    changeVal(event);
  }, [changeVal]);
  var handleMouseUp = (0, _react.useCallback)(function () {
    setIsMouseDown(false);
    document.removeEventListener("mouseup", handleMouseUp);
    document.removeEventListener("mousemove", handleMouseMove);
  }, [setIsMouseDown, handleMouseMove]);
  var onMouseDownResizer = (0, _react.useCallback)(function (event) {
    setIsMouseDown(true);
    changeVal(event);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  }, [changeVal, handleMouseMove, handleMouseUp]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: windowRef,
    className: (0, _classnames.default)(_ChatModule.default.window, isMouseDown && _ChatModule.default.isMouseDown, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Controls.default, {
    focusedChannel: focusedChannel,
    enabledChannels: enabledChannels,
    onClick: toggleChatEnabled,
    onRightClick: focusChannel,
    onDoubleClick: function onDoubleClick() {
      /* TODO: open floating window for chat, disable chat stream within this window */
    },
    className: _ChatModule.default.controls
  }), /*#__PURE__*/_react.default.createElement(_MessagesStream.default, {
    messages: _mockMessages.default,
    enabledChannels: enabledChannels,
    className: _ChatModule.default.messagesStream,
    style: {
      height: height,
      width: width
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: resizerRef,
    onMouseDown: onMouseDownResizer,
    className: _ChatModule.default.resizer
  }));
}